'use client'

import s from "./TopHeader.module.scss";
import {PhoneIcon} from "@/app/[locale]/common/assets/PhoneIcon/PhoneIcon";
import {LANGUAGES_DROPDOWN_MENU_LIST, TOP_HEADER_CONTENT} from "../../../constants/header";
import {EmailIcon} from "@/app/[locale]/common/assets/EmailIcon/EmailIcon";
import {LanguageToggleIcon} from "@/app/[locale]/common/assets/LanguageToggleIcon/LanguageToggleIcon";
import {useState} from "react";
import {CustomIconLink} from "@/app/[locale]/common/components/CustomIconLink/CustomIconLink";
import {CONTACT_INFO} from "../../../constants/main";
import {
    LanguageSelectionDropDownMenu
} from "@/app/[locale]/common/components/LanguageSelectionDropDownMenu/LanguageSelectionDropDownMenu";
import {useLocale} from "next-intl";
import {
    getLanguageAbbreviation
} from "@/app/[locale]/common/utils/functions/getLanguageAbbreviation/getLanguageAbbreviation";

export  const TopHeader = () => {
    const [ isOpen, setIsOpen ] = useState(false);

    const handleOpen = () => setIsOpen(true);
    const handleClose = () => setIsOpen(false);

    const locale = useLocale();
    const currentLanguage = getLanguageAbbreviation(locale);

    return (
        <div className={s.topHeader}>
            <div className={s.topHeader_сontainer}>
                <LanguageSelectionDropDownMenu
                    isOpen={isOpen}
                    trigger={currentLanguage}
                    list={LANGUAGES_DROPDOWN_MENU_LIST}
                    Icon={<LanguageToggleIcon/>}
                    topPaddingContent={'topPaddingSmall'}
                    className={s.link}
                    triggerColor={'whiteTriggerColor'}
                    handleOpen={handleOpen}
                    handleClose={handleClose}
                />

                <div className={s.topHeader_contact}>
                    <CustomIconLink
                        href={'tel:+639985509738'}
                        leftIcon={<PhoneIcon color={'white'}/>}
                        leftMargin={'leftMarginMedium'}
                    >
                        {TOP_HEADER_CONTENT.phoneNumber}
                    </CustomIconLink>

                    <CustomIconLink
                        href={`mailto:${CONTACT_INFO.EMAIL}`}
                        leftIcon={<EmailIcon color={'white'}/>}
                        leftMargin={'leftMarginMedium'}
                    >
                        {TOP_HEADER_CONTENT.email}
                    </CustomIconLink>
                </div>
            </div>
        </div>
    );
};